<template>
  <div>
    <el-dialog
      top="10vh"
      width="380px"
      center
      :title="`${orderManualNotifyObj.username || ''} 手动标记回调`"
      :visible="orderManualNotifyObj.visible"
      @close="handleCancel()"
    >
      <el-form label-width="100px">
        <el-form-item label="平台订单号">
          {{ orderManualNotifyObj.orderId || "-" }}
        </el-form-item>
        <el-form-item label="创建时间">
          {{ orderManualNotifyObj.createdTime || "-" }}
        </el-form-item>
        <el-form-item label="标记回调时间">
          <el-date-picker
            size="small"
            v-model="editData.finishTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>

      <div style="text-align: center; margin-top: 15px">
        <el-button size="small" @click="handleCancel()"> 取消 </el-button>
        <el-button
          :loading="submitLoading"
          size="small"
          type="success"
          @click="handleSubmit()"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import { manualNotify } from "@/api/order";

export default {
  mixins: [mainCommon],
  props: ["orderManualNotifyObj"],
  data() {
    return {
      submitLoading: false,
      editData: {
        finishTime: null,
      },
    };
  },
  watch: {
    orderManualNotifyObj(row) {
      if (row.visible) {
        this.handleDateDefault();
      }
    },
  },
  methods: {
    handleDateDefault() {
      if (this.orderManualNotifyObj.createdTime) {
        var time = new Date(this.orderManualNotifyObj.createdTime);
        time.setMinutes(time.getMinutes() + 30);
        this.editData.finishTime = this.HandleDateYMDFormat(time);
      } else {
        this.editData.finishTime = this.HandleDateYMDFormat(new Date());
      }
    },
    handleCancel() {
      this.editData = {
        finishTime: null,
      };
      this.$emit("update:order-manual-notify-obj", {});
    },
    handleSubmit() {
      if (!this.editData.finishTime) {
        this.$notify.error("标记回调时间未填");
        return;
      }

      this.submitLoading = true;
      manualNotify({
        finishTime: this.editData.finishTime,
        orderId: this.orderManualNotifyObj.id,
        orderType: this.orderManualNotifyObj.orderType,
      })
        .then((res) => {
          this.$notify.success(res.message);
          this.handleCancel();
          this.$emit("HandleGetList");
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/components/dialog/OrderManualNotify.vue